import React from "react";

import { useTranslation } from "utils";

import { FOOTPRINTING_CATEGORY_COLORS } from "consts";

import { FootprintCalculationSummary, FootprintingCategory, FootprintingResultsDataTableRow } from "models";

import { PieChart } from "components";

export const FootprintingPieChart: React.FC<{ footprintCalculationSummary?: FootprintCalculationSummary }> = ({ footprintCalculationSummary }) => {
  const { t } = useTranslation(["footprinting"]);

  if (!footprintCalculationSummary) {
    return <div>{t("resultsPage:noData")}</div>;
  }

  const dataWithColors = (Object.entries(footprintCalculationSummary.tableData) as [FootprintingCategory, FootprintingResultsDataTableRow][])
    .filter(([_, row]) => row.data.totalCO2e > 0)
    .map(([category, row]) => ({
      label: t(`categories.${category}`),
      value: row.data.totalCO2e,
      color: FOOTPRINTING_CATEGORY_COLORS[category],
    }))
    .sort((a, b) => b.value - a.value);

  const pieData = dataWithColors.map((item) => ({ label: item.label, value: item.value }));
  const pieColors = dataWithColors.map((item) => item.color);

  return <PieChart data={pieData} colors={pieColors} tooltipFormatter={(label, value) => `${label}: ${value.toLocaleString()} kg CO₂e`} />;
};
